import LeaderBoardSection from "./LeaderBoardSection"
import LiveSection from "./LiveSection"
import TournamentHeroSection from "./TournamentHeroSection"
import UpcomingSection from "./UpcomingSection"

const TournamentsPage = () => {
  return (
    <div>
      <TournamentHeroSection/>
      <LiveSection/>
      <UpcomingSection/>
      <LeaderBoardSection/>
    </div>
  )
}

export default TournamentsPage
